import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import theme from "../src/assets/styles/theme/theme";
import AppRouter from "./routes";
import NoInternetConnection from './layouts/Shared/components/NoInternetConnection'
import wifi from "./assets/images/icon_actions/wifi.png";
import SetupGate from "./setup/SetupGate";
import SyncStatus from "./data/SyncStatus";
import LogoutGuard from "./data/LogoutGuard";
import ReauthDialog from "./data/ReauthDialog";


const App = () => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        {/* Desktop first-run only: shows the setup wizard, else renders the app. */}
        <SetupGate>
          <NoInternetConnection img={wifi}>
            <AppRouter />
          </NoInternetConnection>
        </SetupGate>
        {/* Desktop-only offline/sync indicator (self-hides when online & synced). */}
        <SyncStatus />
        {/* Desktop-only: explains a declined logout (unsent changes) and offers export. */}
        <LogoutGuard />
        {/* Desktop-only: re-sign-in in place when the server session expires. */}
        <ReauthDialog />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;